import { keys, PlatformFeature } from "@ecologi/shared";
import { useEffect, useMemo } from "react";
import { useStore } from "../../store";
import { useGetConfigCatValueMap } from "../configcat/use-get-configcat-value";

export const useFeatureFlagGuard = (
  allowIfFeatureIs: Partial<Record<PlatformFeature, boolean>>
) => {
  const { user, isCheckingUserSession } = useStore();
  const featureKeys = keys(allowIfFeatureIs);

  const ignoreUser =
    featureKeys.length === 1 &&
    featureKeys.every((key) => key === PlatformFeature.Maintenance);

  const [flags, isCheckingFlag] = useGetConfigCatValueMap(
    featureKeys,
    false,
    ignoreUser
      ? undefined
      : {
          identifier: user?.userId,
          email: user?.email,
        }
  );

  const isAllowed = useMemo(
    () =>
      Object.entries(flags).every(
        ([flag, value]) => value == allowIfFeatureIs[flag]
      ),
    [flags]
  );

  useEffect(() => {
    if (isCheckingUserSession) return;
  }, [isCheckingUserSession, user, isAllowed, isCheckingFlag]);

  return {
    isAllowed,
    isLoading: isCheckingUserSession || isCheckingFlag,
  };
};
